import { useGetActivities, useGetAllTagsOfTagType } from 'api';
import { ActivitiesSortEnum, Activity } from 'oas';
import { filterSideMenuTagsFromTags } from 'reporting/helpers';
import { DAY_CODE_TAG_TYPE, FETCH_ACTIVITIES_PAGE_SIZE, getEndOfDay, getStartOfDay } from 'shared';
import { useSideMenuFilterState } from 'shared/activity-side-menu/use-side-menu-filter-state';
import { useState, useEffect } from 'react';
import { MATCH_DAY, REPORT_TYPE } from 'reporting/constants';
import { useReportTypeStore } from 'shared/state/reporting/reportTypeStore';
import { SelectOption } from '@SBGSports/referee-react';

const getDateForQuery = (date: Date | undefined, shouldNullDate: boolean) => {
    return shouldNullDate || !date ? undefined : date.getTime() / 1000;
};

export const useFetchTags = () => {
    const { data: tags, isLoading: tagsLoading } = useGetAllTagsOfTagType(DAY_CODE_TAG_TYPE);
    const { textFilter, dateFilters } = useSideMenuFilterState();
    const { reportType } = useReportTypeStore();

    const activitiesList = useGetActivities(
        FETCH_ACTIVITIES_PAGE_SIZE,
        ActivitiesSortEnum.StartTimeDesc,
        0,
        undefined,
        getDateForQuery(getStartOfDay(dateFilters.from), false),
        getDateForQuery(getEndOfDay(dateFilters.to), false),
        textFilter,
        {
            getNextPageParam: (lastPage: Activity[], pages: Activity[][]) =>
                lastPage.length >= FETCH_ACTIVITIES_PAGE_SIZE ? pages.length + 1 : undefined,
        },
        undefined,
    );

    const [items, setItems] = useState<SelectOption[]>([]);

    useEffect(() => {
        if (!tags || !activitiesList.data) {
            return;
        }
        const allActivities = activitiesList.data.pages.flatMap((page) => page);
        const updated = filterSideMenuTagsFromTags(tags, '').map((tag) => {
            const isDisabled = !allActivities.some((act) => act.tags?.some((t) => t.name === tag.value));
            return { ...tag, isDisabled };
        });
        // Always enable MATCH_DAY in match_day reports
        if (reportType === REPORT_TYPE.match_day) {
            updated.forEach((t) => {
                if (t.value === MATCH_DAY) {
                    t.isDisabled = false;
                }
            });
        }
        setItems(updated);
    }, [tags, activitiesList.data, reportType]);

    return {
        items,
        isLoading: tagsLoading || activitiesList.isLoading,
    };
};
